<template>
    <v-card
        v-if="isLoading"
        class="informationCard-loader pa-2"
        :ripple="false"
        :style="{
            'width': $vuetify.breakpoint.mdAndDown ? '100px' : '150px',
            'height': $vuetify.breakpoint.mdAndDown ? '50px' : '100px'
        }"
    >
        <v-skeleton-loader
            type="image"
            :max-width="$vuetify.breakpoint.mdAndDown ? 100 : 150"
            :max-height="$vuetify.breakpoint.mdAndDown ? 35 : 85"
        />
    </v-card>
    <div
        v-else-if="!$vuetify.breakpoint.xs && promoterLogo && programLogo"
        class="informationCard"
        :class="{
            'sidebarOpened': (isOpenedProgramInfo || isOpenedSidebar),
            'offsetwithSidebar': !isAlternativeMode && (!isOpenedSidebar && !isOpenedProgramInfo)
        }"
        :style="{ 'bottom': $vuetify.breakpoint.lgAndUp ? 30 + 'px' :  90 + 'px' }"
    >
        <v-card
            class="pa-2"
            @click.prevent="(hasProgramInfo && isAlternativeMode) ? toggleInfoProgram() : null"
            :ripple="false"
        >
            <div
                v-if="promoterLogo"
                class="d-flex justify-center"
            >
                <v-img
                    :src="promoterLogo"
                    :max-width="$vuetify.breakpoint.mdAndDown ? 100 : 150"
                    :height="$vuetify.breakpoint.mdAndDown ? 50 : 100"
                    contain
                />
            </div>
            <h3 v-else-if="hasProgramInfo && isAlternativeMode">
                {{ data.program.name }}
            </h3>
            <div
                v-if="hasProgramInfo && isAlternativeMode"
                class="d-flex justify-end"
            >
                <a href="#">
                    <v-icon>
                        icon-arrow-right
                    </v-icon>
                    <span class="legend">
                        {{$t("sidebar.moreInformation")}}
                    </span>
                </a>
            </div>
        </v-card>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    export default {
        name: 'InformationCard',
        props: [
            'isOpenedProgramInfo',
            'isOpenedSidebar',
            'programName'
        ],
        computed: {
            ...mapGetters([
                'isAlternativeMode',
                'isLoading',
                'logos',
                'programInfo'
            ]),
            promoterLogo() {
                return this.logos && 'promoter' in this.logos ? this.logos['promoter'] : null;
            },
            programLogo() {
                return this.logos && 'program' in this.logos ? this.logos['program'] : null;
            },
            hasProgramInfo() {
                return this.programInfo ? true : false;
            }
        },
        methods: {
            toggleInfoProgram() {
                if (!this.isOpenedProgramInfo) {
                    EventBus.$emit('openProgramInfo');
                    if (this.isOpenedSidebar)
                        EventBus.$emit('toggleSidebar');
                }
                else
                    EventBus.$emit('closeProgramInfo');
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/programInformation/InformationCard.vue